import { useTheme } from "@emotion/react"
import { Box } from "@mui/material"
import { PageCard, PageCardContent } from "components/card"
import { DirectoryOccupantCard } from "components/domains/directory/DirectoryOccupantCard"
import { EmptyData } from "components/EmptyData"
import { ShopIcon } from "components/icons"
import { NavigationControl } from "components/kioskHorizontal/navigation"
import { AppNavigation } from "containers/AppNavigation"
import { useDepartmentStore } from "extensions/em-department-store/hooks/useDepartmentStore"
import { useTranslation } from "providers/i18n"
import React, { useMemo } from "react"
import { useParams } from "react-router-dom"
import { getIcon } from "utils/icon"

export const EMDepartmentStoreKioskOccupantsPage = ({ Layout = Box }) => {
  const { departId } = useParams()
  const { occupants } = useDepartmentStore(departId)
  const t = useTranslation()
  const theme = useTheme()
  const bannerStyleOverrides =
    theme.components[`AppBanner`]?.styleOverrides || {}
  const sideBarStyleOverrides =
    theme.components[`AppSidebar`]?.styleOverrides || {}

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.department) || <ShopIcon />,
    [theme]
  )

  const styleOverrides =
    theme.components[`EmDepartmentStorePage`]?.styleOverrides || {}
  const { occupantCardsContainer = {}, emptyDataWrapper } = styleOverrides

  const { root: bannerRoot } = bannerStyleOverrides
  const { wrapper, body, footer } = sideBarStyleOverrides

  return (
    <Layout
      aside={
        <>
          <PageCard>
            <Box sx={wrapper}>
              <Box sx={bannerRoot}></Box>
              <Box sx={body}>
                <AppNavigation />
              </Box>
              <Box sx={footer}>
                <NavigationControl />
              </Box>
            </Box>
          </PageCard>
        </>
      }
    >
      <PageCard>
        <PageCardContent>
          {occupants?.length === 0 ? (
            <Box sx={emptyDataWrapper}>
              <EmptyData
                icon={emptyIcon}
                primary={t("Coming soon")}
                secondary={t("Stay tuned for the update")}
              />
            </Box>
          ) : (
            <Box sx={occupantCardsContainer}>
              {occupants.map((occupant) => (
                <DirectoryOccupantCard key={occupant.id} data={occupant} />
              ))}
            </Box>
          )}
        </PageCardContent>
      </PageCard>
    </Layout>
  )
}
